const elements = {
  tables: document.body.querySelectorAll('.c-rte table'),
};

function getTableHeadings(table) {
  const tableHeadings = [];
  const headerCells = table.rows[0].cells;

  for (let i = 0; i < headerCells.length; i += 1) {
    tableHeadings.push(headerCells[i].innerText);
  }

  return tableHeadings;
}

function addHeadingLabels(table, labels) {
  for (let r = 1, n = table.rows.length; r < n; r += 1) {
    for (let c = 0, m = table.rows[r].cells.length; c < m; c += 1) {
      table.rows[r].cells[c].dataset.label = labels[c];
    }
  }
}

export function processTable(table) {
  if (table.rows === undefined) {
    return;
  }

  const headings = getTableHeadings(table);
  addHeadingLabels(table, headings);
}

function init() {
  if (!elements.tables.length || elements.tables.rows === undefined) {
    return;
  }

  elements.tables.forEach((table) => {
    if (table.rows === undefined) {
      return;
    }

    const headings = getTableHeadings(table);
    addHeadingLabels(table, headings);
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/entrade/_rte-table/mando-ui.rte-table.js